/**
 * Role of a relation.
 */
export enum RelationRole {
    /**
     * Parent.
     */
    Parent,
    /**
     * Child.
     */
    Child,
}

export type RelationRoleType = "Parent" | "Child";
